module.exports = __webpack_public_path__ + "assets/img/arrow-right.f9cb9360.svg";